import { get } from '@classic/Foundation/Services/ApiService'
import type { SearchResult } from '@core/Areas/Search/types'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const getRacingSearchResults = (searchTerm: string) => {
  trackEvent(keys.searchQuery, { searchQueryText: searchTerm })
  return get<{ results: SearchResult[] }>({
    url: `/api/search/query?q=${searchTerm}&includeUnmatched`,
  })
}
